<template>
    <SelectSite
        class="step-one-container"
        @pick="pick"
        :selectedSite="selectedSite"
        :title="$t('contact.page.site.search.label')"
        :export-contact="true"
        :inclure-termines="true"
    />
    <ReglePastille cle="contact.exportContacts" />
</template>

<script lang="ts">
import SelectSite from '@/modules/SiteList/components/SelectSite.vue';
import { CONTACT } from '../store/mutation-types';
import { Site } from '@/models/Site';
import { defineComponent } from 'vue';
import { store } from '@/plugins/store';
import ReglePastille from '@/components/regles/ReglePastille.vue';

export default defineComponent({
    name: 'SelectSiteContact',
    components: { SelectSite, ReglePastille },
    computed: {
        selectedSite() {
            return store.state.contactState.site;
        },
    },
    methods: {
        pick(site: Site): void {
            if (site) {
                store.commit(`contactState/${CONTACT.SET_SITE}`, site);
            }
        },
    },
});
</script>

<style scoped>
.step-one-container {
    background-color: var(--white);
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 1px 5px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    max-height: calc(100vh - 210px);
}
</style>
